export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15164.6e5f39c1.jpg";